<script setup lang="ts">
import FavoriteProducts from '@/components/about-us/our-family/FavoriteProducts.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';

const favoriteProducts = [
  {
    name: 'Roasted Cashews (Salted)',
    url: '/nuts/cashews/roasted-and-salted.html',
  },
  {
    name: 'Roasted Pistachios (Salted, No Shell)',
    url: '/nuts/pistachios/roasted-and-saltednoshell.html',
  },
  {
    name: 'Chocolate Butter Crunch',
    url: '/chocolatessweets/crunches/chocolate-butter.html',
  },
  {
    name: 'Toffee Chocolate Pistachios',
    url: '/nuts/pistachios/toffee-chocolate.html',
  },
  {
    name: 'Almondolas',
    url: '/nuts/almonds/almondolas.html',
  },
  {
    name: 'Jumbo Roasted Peanuts (In Shell)',
    url: '/nuts/peanuts/jumbo-roasted-inshell.html',
  },
  {
    name: 'Dried Peaches',
    url: '/driedfruit/peaches.html',
  },
  {
    name: 'Dried Apricots',
    url: '/driedfruit/apricots/jumbo.html',
  },
  {
    name: 'Raw Cashews',
    url: '/nuts/cashews/raw.html',
  },
  {
    name: 'Medjool Dates',
    url: '/driedfruit/dates/extra-large-medjool.html',
  },
];
</script>

<template>
  <div>
    <Header4 headerTag="h3">Kenny</Header4>
    <BaseBodyText>
      <strong>Hi! I'm Kenny,</strong> Ken, dad, or even Kendoll (that's a new one my daughter
      bestowed upon me). I started working at the store when I was 4 years old. At that age my dad
      didn't want my brother Sandy (who is 2 years older than me) and me going into work together
      because he didn't want the 2 of us playing around too much and misbehaving, but I would have
      no part of Sandy going without me. I would beat them into the truck in the morning and hide in
      a big toilet paper box, only to pop out of my hiding spot once we pulled up to the store. Back
      then I would sell 1/4 pound bags of peanuts for a dime. And I of course relished having lunch
      at the store. We would have to eat around 11 AM before the lunch time rush came. The big treat
      was a corned beef sandwich on rye and a cherry soda.
    </BaseBodyText>

    <BaseBodyText>
      Working in a long established family business wasn't always the easiest feat. My father was
      really old school and liked to keep things as they were. He was of the mindset that if it
      works, don't change it. Take for example the concepts of displays. Back then we didn't have
      displays for our bulk nuts and dried fruit. Customers had to know to ask for certain products.
      When I presented the idea of getting new counters to actually display our products, I was
      immediately knocked down. After repeatedly pleading my case to no avail, I finally broke down
      and cried to my mom. She would then say, "Now listen Sol, he has good ideas. Don't be so
      stubborn and try what Kenneth suggests." Eventually he listened to my mom.
    </BaseBodyText>

    <BaseBodyText>
      The business was everything to my father, and he trained us well. We were always so busy and
      could never get enough help, so I knew what I had to do. As much as I loved playing sports, I
      just had to quit my high school football and baseball teams to work at the store. I just
      couldn't stand to see my mom working so hard. As I was getting my degree in Civil and
      Environmental Engineering at Newark College of Engineering full time, I was working 40 hours a
      week at the store and selling many of my professors nuts and dried fruits. Upon graduation, my
      dad offered me a position that I could not refuse and have worked here since. The biggest joy
      in the business was when my son Jeffrey decided to take a chance and work for us when he quit
      his investment banking job after graduating from the Wharton School of Business at the
      University of Pennsylvania. Now I am working for my son at Newark Nut / Nuts.com and it is
      marvelous to witness the transformation of this business that my dad started when he was a few
      years younger than Jeffrey is now.
    </BaseBodyText>

    <FavoriteProducts :favoriteProducts>
      I like being with my children, walking, reading, playing tennis, softball, and football, and
      traveling with family and friends.
    </FavoriteProducts>
  </div>
</template>
